/**
 * Shared atoms + constants for the Support Center (Support.js).
 * Extracted during the iter-238 refactor (Feb 2026).
 */
import React from 'react';
import {
  Circle, Clock, Loader2, CheckCircle2, XCircle,
} from 'lucide-react';

// Channel registry — extend here to add Instagram / Telegram / etc.
export const CHANNELS = {
  whatsapp: {
    labelAr: 'واتساب',
    labelEn: 'WhatsApp',
    color: '#25D366',
    icon: 'https://cdn-icons-png.flaticon.com/512/733/733585.png',
  },
  instagram: {
    labelAr: 'انستغرام',
    labelEn: 'Instagram',
    color: '#E4405F',
    icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111463.png',
  },
  telegram: {
    labelAr: 'تيليجرام',
    labelEn: 'Telegram',
    color: '#0088cc',
    icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png',
  },
  facebook: {
    labelAr: 'فيسبوك',
    labelEn: 'Facebook',
    color: '#1877F2',
    icon: '/brand/ast-icon-facebook.png',
  },
};

export const channelOf = (item) => item?.channel || 'whatsapp';

export const STATUS_CONFIG = {
  new:         { label: 'جديد',       labelEn: 'New',         color: 'bg-blue-500',    icon: Circle },
  waiting:     { label: 'في الانتظار', labelEn: 'Waiting',     color: 'bg-amber-500',   icon: Clock },
  in_progress: { label: 'قيد المعالجة', labelEn: 'In Progress', color: 'bg-sky-500',    icon: Loader2 },
  resolved:    { label: 'تم الحل',     labelEn: 'Resolved',    color: 'bg-emerald-500', icon: CheckCircle2 },
  closed:      { label: 'مغلق',       labelEn: 'Closed',      color: 'bg-gray-500',    icon: XCircle },
};

export function ChannelIcon({ channel = 'whatsapp', size = 14, showLabel = false, className = '' }) {
  const c = CHANNELS[channel] || CHANNELS.whatsapp;
  return (
    <span
      className={`inline-flex items-center gap-1 ${className}`}
      title={c.labelEn}
      style={{ fontSize: `${Math.max(9, size - 4)}px`, color: c.color }}
    >
      <img src={c.icon} alt={c.labelEn} width={size} height={size} className="object-contain" />
      {showLabel && <span className="font-medium">{c.labelEn}</span>}
    </span>
  );
}

export function StatusBadge({ status, isAr }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.new;
  const Icon = config.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium text-white ${config.color}`}>
      <Icon className="h-3 w-3" />
      {isAr ? config.label : config.labelEn}
    </span>
  );
}

// iter-238 — Formatters shared between the conversation list + chat area.
export const formatTime = (timestamp, isAr) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  return date.toLocaleTimeString(isAr ? 'ar-SA' : 'en-GB', { hour: '2-digit', minute: '2-digit' });
};

export const formatDate = (timestamp, isAr, t) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (date.toDateString() === today.toDateString()) return t('اليوم', 'Today');
  if (date.toDateString() === yesterday.toDateString()) return t('أمس', 'Yesterday');
  return date.toLocaleDateString(isAr ? 'ar-SA' : 'en-GB', { day: 'numeric', month: 'short' });
};
